import { useRef, useState } from 'react'
import { useUserChatBubbleAttachments } from './useUserChatBubbleAttachments'
import { useUserChatBubbleCopy } from './useUserChatBubbleCopy'
import { useUserChatBubbleGallery } from './useUserChatBubbleGallery'
import { useUserChatBubbleMoreMenu } from './useUserChatBubbleMoreMenu'

export function useUserChatBubbleCoreState(props) {
  const {
    text = '',
    attachments = [],
    onReply,
    onForward,
    onPinForEveryone,
    onDelete,
    showDeleteAction = true,
  } = props

  const bubbleAnchorRef = useRef(null)
  const [moreMenuAnchor, setMoreMenuAnchor] = useState(null)
  const [reactionPickerAnchorEl, setReactionPickerAnchorEl] = useState(null)
  const { copied, handleCopy } = useUserChatBubbleCopy(text)
  const menu = useUserChatBubbleMoreMenu({
    onReply,
    onForward,
    onPinForEveryone,
    onDelete,
    text,
    copied,
    handleCopy,
    showDeleteAction,
  })
  const attachmentState = useUserChatBubbleAttachments(attachments)
  const gallery = useUserChatBubbleGallery(attachmentState.imageAttachmentsOnly)

  return {
    bubbleAnchorRef,
    moreMenuAnchor,
    setMoreMenuAnchor,
    reactionPickerAnchorEl,
    setReactionPickerAnchorEl,
    copied,
    handleCopy,
    menu,
    attachmentState,
    gallery,
  }
}
